import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import {useField} from 'formik';

import 'react-datepicker/dist/react-datepicker.css';
import GenericDatePicker from '../generic-date-picker/GenericDatePicker';

function FormikDayTimePicker({name, disabled, label, onChange, popperPlacement, popperModifiers}) {
    let [, fieldMeta, fieldHelpers] = useField(name);

    return (
        <Wrapper>
            <GenericDatePicker
                name={name}
                label={label}
                showTimeSelect={true}
                showWeekNumbers={false}
                disabled={disabled}
                onKeyDown={(e) => {
                    e.preventDefault();
                }}
                selected={fieldMeta.value ? new Date(+fieldMeta.value) : null}
                onChange={(v) => {
                    fieldHelpers.setValue(Date.parse(v));
                    if (_.isFunction(onChange)) onChange(v);
                }}
                dateFormat={'dd MMM yyyy, HH:mm'}
                popperPlacement={popperPlacement}
                popperModifiers={popperModifiers}
            />
        </Wrapper>
    );
}

const Wrapper = styled.div`
    .react-datepicker__navigation.react-datepicker__navigation--next.react-datepicker__navigation--next--with-time {
        right: 86px;
    }
`;

export {FormikDayTimePicker};
